const theme = {
  black: "#000000",
  white: "#FFFFFF",
  lightGrey: "#B0B0B0",
  middleGrey: "#717171",
  deepGrey: "#222222",
  hoverGrey: "#DBDBDB",
  ageOrange: "#f98700",
  ageRed: "red",
  ageGreen: "green",
};

export default theme;
